export default __webpack_public_path__ + "static/performance-btn-large-05ac041339d49e8f208d74046e50e0d5.jpeg";